/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sellers_Stats_GamesInputs */

const id_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game`)
};

const ms_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan`)
};

const da_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil`)
};

const de_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiele`)
};

const en_us2_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games`)
};

const es_es2_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos`)
};

const es_mx2_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos`)
};

const fil_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Laro`)
};

const fr_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux`)
};

const it_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi`)
};

const hu_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játékok`)
};

const nl_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games`)
};

const no_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill`)
};

const pl_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gry`)
};

const pt_br2_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos`)
};

const pt_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos`)
};

const ro_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri`)
};

const fi_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelit`)
};

const sv_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spel`)
};

const vi_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game`)
};

const tr_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyunlar`)
};

const cs_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hry`)
};

const bg_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игри`)
};

const ru_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игр`)
};

const uk_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ігор`)
};

const ar_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الألعاب`)
};

const hi_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेम`)
};

const th_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกม`)
};

const ja_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーム`)
};

const zh_cn2_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游戏`)
};

const zh_hant1_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遊戲`)
};

const ko_sellers_stats_games = /** @type {(inputs: Sellers_Stats_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임`)
};

/**
* | output |
* | --- |
* | "Games" |
*
* @param {Sellers_Stats_GamesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sellers_stats_games = /** @type {((inputs?: Sellers_Stats_GamesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sellers_Stats_GamesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sellers_stats_games(inputs)
	if (locale === "ms") return ms_sellers_stats_games(inputs)
	if (locale === "da") return da_sellers_stats_games(inputs)
	if (locale === "de") return de_sellers_stats_games(inputs)
	if (locale === "en-US") return en_us2_sellers_stats_games(inputs)
	if (locale === "es-ES") return es_es2_sellers_stats_games(inputs)
	if (locale === "es-MX") return es_mx2_sellers_stats_games(inputs)
	if (locale === "fil") return fil_sellers_stats_games(inputs)
	if (locale === "fr") return fr_sellers_stats_games(inputs)
	if (locale === "it") return it_sellers_stats_games(inputs)
	if (locale === "hu") return hu_sellers_stats_games(inputs)
	if (locale === "nl") return nl_sellers_stats_games(inputs)
	if (locale === "no") return no_sellers_stats_games(inputs)
	if (locale === "pl") return pl_sellers_stats_games(inputs)
	if (locale === "pt-BR") return pt_br2_sellers_stats_games(inputs)
	if (locale === "pt") return pt_sellers_stats_games(inputs)
	if (locale === "ro") return ro_sellers_stats_games(inputs)
	if (locale === "fi") return fi_sellers_stats_games(inputs)
	if (locale === "sv") return sv_sellers_stats_games(inputs)
	if (locale === "vi") return vi_sellers_stats_games(inputs)
	if (locale === "tr") return tr_sellers_stats_games(inputs)
	if (locale === "cs") return cs_sellers_stats_games(inputs)
	if (locale === "bg") return bg_sellers_stats_games(inputs)
	if (locale === "ru") return ru_sellers_stats_games(inputs)
	if (locale === "uk") return uk_sellers_stats_games(inputs)
	if (locale === "ar") return ar_sellers_stats_games(inputs)
	if (locale === "hi") return hi_sellers_stats_games(inputs)
	if (locale === "th") return th_sellers_stats_games(inputs)
	if (locale === "ja") return ja_sellers_stats_games(inputs)
	if (locale === "zh-CN") return zh_cn2_sellers_stats_games(inputs)
	if (locale === "zh-Hant") return zh_hant1_sellers_stats_games(inputs)
	return ko_sellers_stats_games(inputs)
});
export { sellers_stats_games as "sellers.stats.games" }